/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  DeleteProductionSiteMutationResponse,
  DeleteProductionSitePathParams,
} from "../types/DeleteProductionSite.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const deleteProductionSiteMutationKey = () =>
  [{ url: "/v1/production-site/:productionSiteId" }] as const

export type DeleteProductionSiteMutationKey = ReturnType<
  typeof deleteProductionSiteMutationKey
>

/**
 * @summary Delete a production site
 * {@link /v1/production-site/:productionSiteId}
 */
export async function deleteProductionSite(
  productionSiteId: DeleteProductionSitePathParams["productionSiteId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteProductionSiteMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "DELETE",
    url: `/v1/production-site/${productionSiteId}`,
    ...requestConfig,
  })
  return res
}

export function deleteProductionSiteMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const mutationKey = deleteProductionSiteMutationKey()
  return mutationOptions<
    ResponseConfig<DeleteProductionSiteMutationResponse>,
    ResponseErrorConfig<Error>,
    { productionSiteId: DeleteProductionSitePathParams["productionSiteId"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ productionSiteId }) => {
      return deleteProductionSite(productionSiteId, config)
    },
  })
}

/**
 * @summary Delete a production site
 * {@link /v1/production-site/:productionSiteId}
 */
export function useDeleteProductionSite<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteProductionSiteMutationResponse>,
      ResponseErrorConfig<Error>,
      { productionSiteId: DeleteProductionSitePathParams["productionSiteId"] },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? deleteProductionSiteMutationKey()

  const baseOptions = deleteProductionSiteMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<DeleteProductionSiteMutationResponse>,
    ResponseErrorConfig<Error>,
    { productionSiteId: DeleteProductionSitePathParams["productionSiteId"] },
    TContext
  >

  return useMutation<
    ResponseConfig<DeleteProductionSiteMutationResponse>,
    ResponseErrorConfig<Error>,
    { productionSiteId: DeleteProductionSitePathParams["productionSiteId"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DeleteProductionSiteMutationResponse>,
    ResponseErrorConfig<Error>,
    { productionSiteId: DeleteProductionSitePathParams["productionSiteId"] },
    TContext
  >
}
